import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerServiceSectionComponent } from './customer-service-section.component';

@NgModule({
  imports: [CommonModule, MatListModule, SharedModule, CustomerServiceSectionComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoCustomerServiceSectionComponent: {
          component: CustomerServiceSectionComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [CustomerServiceSectionComponent],
})
export class CustomerServiceSectionModule {}
